import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import CountrySelector from "../country-selector/country-selector";
import Flag from 'react-world-flags'
import t from 'helpers/I18n'

const PhoneInput = ({country,value, name, id, onChange, getPhoneCode, max}) => {
    const [inputValue, setInputValue] = useState(value || "4")
    const [showCountryList, setShowCountryList] = useState(false)
    const [selectedCountry, setSelectedCountry] = useState({
            callingCode: country?.internal_mobile_country_code || "32",
            code: country?.internal_mobile_country_calling_code || "BE",
    })

    const numFormat = (e) => {
        if(e.target.value.length < 1 ){
            setInputValue("")
        }

        if(e.target.value.length > 0 && /^[0-9]*$/.test(e.target.value)) {
            if(selectedCountry.code === "BE" && e.target.value.length <= 10 ){
                setInputValue(e.target.value)
            }
            if(selectedCountry.code !== "BE" && e.target.value.length <= max ){
                setInputValue(e.target.value)
            }
        }
    }

    const handleInputChange = (e) => {
        onChange(e)
        numFormat(e)
    }

    const formatBelgiumNum = (country) => {
        if(country.code === "BE") {
            setInputValue('4')
        } else {
            setInputValue('')
        }
    }

    const getCountry = (country) => {
        setSelectedCountry(country)
        getPhoneCode("phoneCode", {
            callingCode: country.callingCode,
            code: country.code
        })
        formatBelgiumNum(country)
    }

    useEffect(() => {
        getPhoneCode("phoneCode", {
            callingCode: selectedCountry.callingCode,
            code: selectedCountry.code})
    }, [inputValue])

    return (
        <>
            <div className="phone-input">
                <div className={"phone-input__country-code"} >
                    <div onClick={() => {setShowCountryList(true)}} >
                        <Flag code={selectedCountry.code}  />
                        <span>
                            + {selectedCountry.callingCode}
                        </span>
                    </div>
                </div>

                <input
                    name={name}
                    id={id}
                    type="text"
                    value={inputValue}
                    onChange={handleInputChange}
                    placeholder=" "
                    autoComplete="off"
                /> 
            </div>

            {showCountryList &&
                <CountrySelector
                    phoneCode
                    title={t('personal_infos.country_dropdown.title')}
                    selected={selectedCountry.code}
                    close={() => {setShowCountryList(false)}}
                    getCountry={getCountry}
                />}

        </>
    )
}



PhoneInput.propTypes = {
    defaultCountry: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    onChange: PropTypes.func,
    getPhoneCode: PropTypes.func,
    country: PropTypes.any,
};

export default PhoneInput